"use client";

import React from "react";
import { BlurFade } from "@/components/ui/blur-fade";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

interface FAQ {
  question: string;
  answer: string;
}

interface DownloadFAQProps {
  title: string;
  items: FAQ[];
}

const DownloadFAQ = ({ title, items }: DownloadFAQProps) => {
  return (
    <section className="py-24 px-6 bg-muted">
      <div className="container max-w-4xl mx-auto flex flex-col items-center gap-16">
        {/* Header */}
        <BlurFade delay={0.1}>
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-center text-foreground">
            {title}
          </h2>
        </BlurFade>

        {/* Accordion Container */}
        <BlurFade delay={0.2} className="w-full">
          <Accordion type="single" collapsible className="w-full">
            {items.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-zinc-200"
              >
                <AccordionTrigger className="text-foreground hover:text-primary">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-foreground/60">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </BlurFade>
      </div>
    </section>
  );
};

export default DownloadFAQ;

